// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QgjN_dAwHXI6oYfHwFbv {
  width: 280px;
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 10px 38px -10px rgba(22, 23, 24, 0.35), 0 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation: gULGi4YgXQsFxRL21wav 0.2s ease-out;
  z-index: 10000;
}
@keyframes gULGi4YgXQsFxRL21wav {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.gKEpjRYaIo1vW7xyrjIe {
  fill: white;
}

.SCLmUsSbcdW4aCgzKX7Y {
  margin-bottom: 12px;
}

.hymZWWHkSFVnfx7R00gK {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.bujWdqk3FlfZqVb7dmgw {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.LBsk4PYVVLTMgSV89b5m {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 20px;
  flex-shrink: 0;
}

.UyptpoiRXj4d_2h3m4XI {
  flex: 1;
  min-width: 0;
}

.FZOhkqWeAroAIvyzjWy0 {
  font-weight: 600;
  font-size: 15px;
  color: #1a1a1a;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.w0Rk_z_RqG2HHYPRX44j {
  font-size: 13px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 4px;
}

.mGqgx_KE_aCk8_YE3VMc {
  font-size: 13px;
  color: #999;
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Lj2EAPDj0hRiS1sMvJK0 {
  display: flex;
  justify-content: flex-start;
}

.ZTeFeAQOUSztsPcSv8Gx {
  display: inline-block;
  padding: 4px 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.GQ4g6vNcz3HDNQktrwmH {
  height: 1px;
  background: #e5e5e5;
  margin: 12px 0;
}

.uKME5vcqT44gb4ocayJP {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.wNtlZ7ZmpDl1mswjRcqG {
  width: 100%;
  padding: 10px 16px;
  background: #f3f4f6;
  color: #1a1a1a;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wNtlZ7ZmpDl1mswjRcqG:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
}

.cdKlGHcN3691zkE6QCUM {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
}
.cdKlGHcN3691zkE6QCUM:hover {
  opacity: 0.9;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.aWgUQABryZDp0QeazVZQ {
  background: #f3f4f6;
  color: #1a1a1a;
  border: 1px solid #e5e7eb;
}
.aWgUQABryZDp0QeazVZQ:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}

@media (prefers-color-scheme: dark) {
  .QgjN_dAwHXI6oYfHwFbv {
    background: #1a1a1a;
    box-shadow: 0 10px 38px -10px rgba(0, 0, 0, 0.5), 0 10px 20px -15px rgba(0, 0, 0, 0.3);
  }
  .gKEpjRYaIo1vW7xyrjIe {
    fill: #1a1a1a;
  }
  .FZOhkqWeAroAIvyzjWy0 {
    color: #f0f0f0;
  }
  .w0Rk_z_RqG2HHYPRX44j,
  .mGqgx_KE_aCk8_YE3VMc {
    color: #999;
  }
  .GQ4g6vNcz3HDNQktrwmH {
    background: #333;
  }
  .wNtlZ7ZmpDl1mswjRcqG {
    background: #2a2a2a;
    color: #f0f0f0;
    border-color: #333;
  }
  .wNtlZ7ZmpDl1mswjRcqG:hover {
    background: #333;
    border-color: #404040;
  }
  .cdKlGHcN3691zkE6QCUM {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
  }
  .cdKlGHcN3691zkE6QCUM:hover {
    opacity: 0.9;
  }
  .aWgUQABryZDp0QeazVZQ:hover {
    background: #2a1515;
    border-color: #7f1d1d;
    color: #fca5a5;
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/auth/components/ProfileHoverCard.module.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,6FACE;EAEF,6CAAA;EACA,cAAA;AAHF;AAKE;EACE;IACE,UAAA;IACA,0BAAA;EAHJ;EAKE;IACE,UAAA;IACA,wBAAA;EAHJ;AACF;;AAOA;EACE,WAAA;AAJF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALF;;AAQA;EACE,OAAA;EACA,YAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AALF;;AAQA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,2BAAA;AALF;;AAQA;EACE,qBAAA;EACA,iBAAA;EACA,6DAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AALF;;AAQA;EACE,WAAA;EACA,mBAAA;EACA,cAAA;AALF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AANF;AAQE;EACE,mBAAA;EACA,qBAAA;AANJ;;AAUA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;AAPF;AASE;EACE,YAAA;EACA,6DAAA;AAPJ;;AAWA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AARF;AAUE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AARJ;;AAaA;EACE;IACE,mBAAA;IACA,sFACE;EAXJ;EAeA;IACE,aAAA;EAbF;EAgBA;IACE,cAAA;EAdF;EAiBA;;IAEE,WAAA;EAfF;EAkBA;IACE,gBAAA;EAhBF;EAmBA;IACE,mBAAA;IACA,cAAA;IACA,kBAAA;EAjBF;EAmBE;IACE,gBAAA;IACA,qBAAA;EAjBJ;EAqBA;IACE,6DAAA;IACA,YAAA;IACA,YAAA;EAnBF;EAqBE;IACE,YAAA;EAnBJ;EAwBE;IACE,mBAAA;IACA,qBAAA;IACA,cAAA;EAtBJ;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hoverCardContent": `QgjN_dAwHXI6oYfHwFbv`,
	"slideUpAndFade": `gULGi4YgXQsFxRL21wav`,
	"hoverCardArrow": `gKEpjRYaIo1vW7xyrjIe`,
	"profileSection": `SCLmUsSbcdW4aCgzKX7Y`,
	"profileHeader": `hymZWWHkSFVnfx7R00gK`,
	"userAvatar": `bujWdqk3FlfZqVb7dmgw`,
	"userAvatarPlaceholder": `LBsk4PYVVLTMgSV89b5m`,
	"userDetails": `UyptpoiRXj4d_2h3m4XI`,
	"userName": `FZOhkqWeAroAIvyzjWy0`,
	"userEmail": `w0Rk_z_RqG2HHYPRX44j`,
	"publicUsername": `mGqgx_KE_aCk8_YE3VMc`,
	"planBadge": `Lj2EAPDj0hRiS1sMvJK0`,
	"proBadge": `ZTeFeAQOUSztsPcSv8Gx`,
	"divider": `GQ4g6vNcz3HDNQktrwmH`,
	"actionsSection": `uKME5vcqT44gb4ocayJP`,
	"actionButton": `wNtlZ7ZmpDl1mswjRcqG`,
	"editProfileButton": `cdKlGHcN3691zkE6QCUM`,
	"logoutButton": `aWgUQABryZDp0QeazVZQ`
};
export default ___CSS_LOADER_EXPORT___;
